/* global btoa, atob */
/**
 * Base64 encodes a string. This method is safe with unicode strings.
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa#Unicode_strings
 */
export const base64Encode = (str: string): string => btoa(unescape(encodeURIComponent(str)));

/**
 * Base64 decodes a string. This method is safe with unicode strings.
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa#Unicode_strings
 */
export const base64Decode = (str: string): string => decodeURIComponent(escape(atob(str)));

/**
 * Base64 encoding for URL and filename safety:
 * https://tools.ietf.org/html/rfc4648#section-5
 */
export const base64EncodeUrlSafe = (str: string): string => {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
};

/**
 * Base64 decoding for URL and filename safety:
 * https://tools.ietf.org/html/rfc4648#section-5
 */
export const base64DecodeUrlSafe = (str: string): string => {
  // The encoding method strips the equal signs, so add them back.
  const offset = str.length % 4;
  const padding = (offset === 2) ? '=='
                : (offset === 3) ? '='
                : '';

  // Sanitize the string so it's a properly formatted base64 encoded string.
  const encoded = `${str.replace(/-/g, '+').replace(/_/g, '/')}${padding}`;
  return atob(encoded);
};

/**
 * Crude case insensitive comparator for strings.
 */
export const caseInsensitiveComparator = (a: string, b: string): 1 | 0 | -1 => {
  const aLower = a.toLowerCase();
  const bLower = b.toLowerCase();

  if (aLower > bLower) {
    return 1;
  } else if (aLower < bLower) {
    return -1;
  } else {
    return 0;
  }
};
